export default __webpack_public_path__ + "static/media/photo--sm--kara11.6547f91d.jpg";